import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ErrorDialogComponentBase } from '../../error-dialog-component-base';

@Component({
  standalone: false,
  selector: 'app-error-dialog',
  templateUrl: './error.dialog.component.html'
})

export class ErrorDialogComponent extends ErrorDialogComponentBase {

  private supportedCodes = [202];
  public generalReason: string;
  public errors: any[];
  public title: string;

  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(true);

    if (data) {
      this.fill(data.error);
    }
  }

  public ok() {
    this.dialogRef.close(true);
  }

  private fill(error: any) {

    if (!error) {
      return;
    }

    const currentError = error.error || error;

    this.generalReason = currentError ? currentError.generalReason : '';

    const errors = currentError.errors;

    if (!errors || errors.length === 0) {
      this.title = 'errors.application.title.one';
      return;
    }

    this.title = `errors.application.title.${errors.length > 1 ? 'list' : 'one'}`;

    this.errors = errors.map(item => {

      if (item.errorCode) {
        item.useCode = this.supportedCodes.includes(item.errorCode);
      }

      return item;
    });
  }

  close(): void {
    this.dialogRef.close();
  }

}
